import * as azdev from "azure-devops-node-api";
import * as ca from "azure-devops-node-api/CoreApi"
import * as wita from "azure-devops-node-api/WorkItemTrackingApi"


class AzureHelper {
    organizationName = ""
    organizationUri = ""
    azurePersonalAccessToken = ""
    connection = {}

    constructor(orgName, orgUri, azurePersonalAccessToken) {
        this.organizationName = orgName;
        this.organizationUri = orgUri + orgName;
        this.azurePersonalAccessToken = azurePersonalAccessToken;
        this.connection = this.createConnection()
    }

    createConnection() {
        try {
            let authHandler = azdev.getPersonalAccessTokenHandler(this.azurePersonalAccessToken.toString());
            let connection = new azdev.WebApi(this.organizationUri.toString(), authHandler);
            return connection;
        } catch (error) {
            console.log(error);
        }
    }

    async getProjects() {
        try {
            var coreInstance = ca.CoreApi;
            coreInstance = await this.connection.getCoreApi();
            
            let projects = await coreInstance.getProjects();
            projects = await projects.sort(function (a, b) { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
            return projects;
        } catch (error) {
            console.log(error);
        }
    }

    async getQueryByWiql(teamProject) {
        try {
            var witaInstance = wita.WorkItemTrackingApi;
            witaInstance = await this.connection.getWorkItemTrackingApi();

            const query = {
                "query": `select [state], [title], [description] from WorkItems where [System.TeamProject] = '${teamProject}' and ([System.WorkItemType] = 'Task') ORDER BY [System.Id]`
            }

            let workItems = await witaInstance.queryByWiql(query)
            return workItems;
        } catch (error) {
            console.log(error);
        }
    }

}

export default AzureHelper;